import request from "./http";
import qs from 'qs'

//能源类型 --- 查询所有能源类型
// 
export function getAllEnergyType() {
    return request({
        url: "/energyType/getAllEnergyType",
        method: "get",
 
    });
}


//能源类型 --- 查询所有应用类型组
// 
export function getAllTypeByGroup() {
    return request({
        url: "/energyType/getAllTypeByGroup",
        method: "get",
 
    });
}


//能源类型 --- 根据应用类型组Id查询应用类型
// 
export function getAppTypeByGroupId(params) {
    return request({
        url: "/energyType/getAppTypeByGroupId",
        method: "get",
        params
 
    });
}

//能源->添加-修改能源类型
// 
export function saveEnergyType(params) {
    return request({
        url: "/energyType/saveEnergyType",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}

//能源->通过Id删除能源类型
// 
export function deleteEnergyType(params) {
    return request({
        url: "/energyType/deleteEnergyType",
        method: "delete",
        params
    });
}